import "./proddesign.css";

export default function ProdDesign() {
    return (
        <div className="prodDesign">
            <h3>Coming Soon...</h3>
        </div>
    )
}
